import { useEffect, useState } from 'react';

const navLinks = [
  { href: '#home', label: '首页' },
  { href: '#today', label: '今日更新' },
  { href: '#ranking', label: '热门榜单' },
  { href: '#editor', label: '编辑推荐' },
  { href: '#new', label: '新作首发' },
  { href: '#score', label: '高分漫画' },
  { href: '#popular', label: '人气连载' },
  { href: '#faq', label: '常见问题' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 shadow-sm backdrop-blur-md'
          : 'bg-background-950/50 backdrop-blur-sm'
      }`}
    >
      <nav className="flex h-16 items-center justify-between px-4 md:px-6">
        <a
          href="#home"
          className="font-heading flex items-center gap-2 text-xl md:text-2xl whitespace-nowrap"
          aria-label="卡通动漫第一页 首页"
        >
          <span
            className={`inline-flex h-9 w-9 items-center justify-center rounded-lg ${
              scrolled ? 'bg-primary-500 text-background-50' : 'bg-primary-500 text-background-50'
            }`}
          >
            <i className="ri-movie-2-fill text-lg"></i>
          </span>
          <span className={scrolled ? 'text-foreground-950' : 'text-background-50'}>
            动漫第一页
          </span>
        </a>

        <div className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`rounded-md px-3 py-2 text-sm whitespace-nowrap transition-colors hover:text-primary-500 ${
                scrolled ? 'text-foreground-700' : 'text-background-100 hover:bg-white/10'
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#today"
            className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-4 py-2 text-sm font-bold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
          >
            <i className="ri-refresh-line"></i>
            去看更新
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="展开菜单"
            className={`inline-flex h-9 w-9 items-center justify-center rounded-lg lg:hidden ${
              scrolled ? 'text-foreground-950' : 'text-background-50'
            }`}
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <div className="grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md bg-background-100 px-3 py-2 text-sm text-foreground-700 whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}